import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ion-padding-horizontal" }
const _hoisted_2 = { class: "ion-margin-bottom ion-margin-start" }
const _hoisted_3 = {
  key: 0,
  class: "ion-margin-top ion-margin-start"
}

import {
  AlertInformation,
  AnnouncementSummary,
  AnnouncementSummaryProps,
  Course,
  CustomElement,
  OrderedCardsList,
  User,
} from "@/types";
import {
  executeLink,
  getBreakpoint,
  getCurrentElement,
  getCurrentLanguage,
  getCustomMessage,
  getIcon,
  isSmaller,
} from "@/utils";
import { IonModal, IonAlert } from "@ionic/vue";
import { nextTick, onBeforeUnmount, onMounted, ref, Ref, watch } from "vue";
import { useStore } from "vuex";

type availableModal =
  | "announcement"
  | "publish_announcement"
  | "empty_titles_or_messages"
  | "no_selected_sections"
  | "publish"
  | "error";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementsComponent',
  async setup(__props) {

let __temp: any, __restore: any

const setupModalAndOpen = async () => {
  const window: availableModal = store.state.event.event;
  const failed_sections: string[] = [];

  switch (window) {
    case "announcement":
      announcement_title = store.state.event.data.title;
      announcement_id = store.state.event.data.announcement_id;
      announcement_open.value = true;
      break;
    case "publish_announcement":
      publishment_open.value = true;
      break;
    case "empty_titles_or_messages":
      alert_information.message = getCurrentElement("empty_titles_or_messages");
      alert_open.value = true;
      break;
    case "no_selected_sections": //<!-- TODO (5): non ha funzionato
      alert_information.message = getCurrentElement("no_selected_sections");
      alert_open.value = true;
      break;
    case "publish":
      await executeLink(
        "/v1/announcements?teacher_id=" +
          user.id +
          "&course_id=" +
          course_id +
          "&session_id=" +
          session_id,
        () => "",
        () => {
          store.state.event.event = "error";
          store.state.event.data.message = getCurrentElement("announcement_error");
          setupModalAndOpen();
          return "";
        },
        "post",
        {
          sections: store.state.event.data.sections,
          italian_title: store.state.event.data.title,
          english_title: store.state.event.data.title,
          italian_message: store.state.event.data.message,
          english_message: store.state.event.data.message,
        }
      );
      if (failed_sections.length > 0) {
        alert_information.message =
          getCurrentElement("message_not_sent_sections") +
          ": " +
          failed_sections.join(" ");
        alert_open.value = true;
      }
      updateMessages();
      break;
    case "error":
      alert_information.title = getCurrentElement("error");
      alert_information.message = store.state.event.data.message;
      alert_open.value = true;
      break;
  }
};
const closeModal = (window: availableModal) => {
  switch (window) {
    case "announcement":
      announcement_open.value = false;
      break;
    case "publish_announcement":
      publishment_open.value = false;
      break;
    case "error":
      alert_open.value = false;
      break;
  }
};

const updateMessages = async () => {
  messages.cards[""] = await executeLink(
    "/v1/project_classes/" +
      course_id +
      "/" +
      session_id +
      "/announcements?" +
      (user.type == "teacher" ? "&section=" + selected_section.value : ""),
    (response) =>
      response.data.data.map((a: AnnouncementSummaryProps) =>
        new AnnouncementSummary(a).toCard()
      ),
    () => []
  );
  trigger.value++;
};

const updateBreakpoint = () => {
  breakpoint.value = getBreakpoint(window.innerWidth);
};

const store = useStore();
const user = User.getLoggedUser() as User;
const sections_use: boolean = store.state.sections_use;
const language = getCurrentLanguage();
const alert_information: AlertInformation = store.state.alert_information;
alert_information.title = getCurrentElement("error");
alert_information.buttons = [getCurrentElement("ok")];

const announcement_open = ref(false);
const publishment_open = ref(false);
const divided_path = window.location.pathname.split("/");
const course_id = divided_path[divided_path.length - 2];
const session_id = divided_path[divided_path.length - 1];
const trigger = ref(0);
const sections: { id: string }[] = [];
const tmp_sections: Set<string> = new Set();
const buttons: CustomElement[] = [
  {
    id: "new_announcement",
    type: "string_icon",
    linkType: "event",
    content: {
      event: "publish_announcement",
      icon: getIcon("add"),
      text: getCurrentElement("new_announcement"),
      whole_link: true,
    },
    ...store.state.button_css,
  },
];
const alert_open = ref(false);
const messages: OrderedCardsList = {
  order: [],
  cards: {
    "": [],
  },
};
const breakpoint = ref(getBreakpoint(window.innerWidth));
const course: Course | undefined = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/courses/" + course_id,
  (response) => new Course(response.data.data),
  () => undefined
))),
  __temp = await __temp,
  __restore(),
  __temp
);

let selected_section: Ref<string>;
let announcement_title: string;
let announcement_id: string;

if (user.type == "teacher") {
  (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v2/teachers/" +
      user.id +
      "/my_project_classes?session_id=" +
      session_id +
      "&course_id=" +
      course_id,
    (response) =>
      response.data.data.map((a: any) => tmp_sections.add(a.section))
  ))),
  await __temp,
  __restore()
);
  ;(
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
    "/v2/teachers/" +
      user.id +
      "/associated_project_classes?session_id=" +
      session_id +
      "&course_id=" +
      course_id,
    (response) =>
      response.data.data.map((a: any) => tmp_sections.add(a.section))
  ))),
  await __temp,
  __restore()
);

  for (const section of tmp_sections) {
    sections.push({
      id: section,
    });
  }
  selected_section = ref(sections[0].id);
  watch(selected_section, async () => {
    await updateMessages();
  });
}

;(
  ([__temp,__restore] = _withAsyncContext(() => updateMessages())),
  await __temp,
  __restore()
);

onMounted(() =>
  nextTick(() => {
    window.addEventListener("resize", updateBreakpoint);
  })
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateBreakpoint);
});

return (_ctx: any,_cache: any) => {
  const _component_announcements_publisher = _resolveComponent("announcements-publisher")!
  const _component_loading_component = _resolveComponent("loading-component")!
  const _component_announcement_viewer = _resolveComponent("announcement-viewer")!
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_custom_select = _resolveComponent("custom-select")!
  const _component_list_card = _resolveComponent("list-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal(_unref(store).state.event.event)))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonModal), {
      id: "publish_announcement",
      "is-open": publishment_open.value,
      onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (closeModal('publish_announcement'))),
      class: "fit"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_announcements_publisher, {
              sections: sections,
              current_section_index: 
              sections.findIndex((a) => a.id == _unref(selected_section))
            ,
              onSignal_event: _cache[1] || (_cache[1] = ($event: any) => (setupModalAndOpen())),
              onClose: _cache[2] || (_cache[2] = ($event: any) => (closeModal('publish_announcement')))
            }, null, 8, ["current_section_index"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_unref(IonModal), {
      id: "announcement",
      "is-open": announcement_open.value,
      onDidDismiss: _cache[5] || (_cache[5] = ($event: any) => (closeModal('announcement'))),
      class: "fit"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(_component_announcement_viewer, {
              title: _unref(announcement_title),
              id: _unref(announcement_id),
              onClose: _cache[4] || (_cache[4] = ($event: any) => (closeModal('announcement')))
            }, null, 8, ["title", "id"])
          ]),
          fallback: _withCtx(() => [
            _createVNode(_component_loading_component)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ionic_element, {
        element: 
          _unref(getCustomMessage)(
            'title',
            _unref(course) != undefined ? _unref(course)[`${_unref(language)}_title`] : '',
            'title',
            undefined,
            {
              label: {
                title_font: true,
              },
            }
          )
        
      }, null, 8, ["element"])
    ]),
    (_unref(user).type == 'teacher')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (button) => {
            return _createVNode(_component_ionic_element, {
              key: button.id,
              element: button,
              onSignal_event: _cache[6] || (_cache[6] = ($event: any) => (setupModalAndOpen()))
            }, null, 8, ["element"])
          }), 64)),
          (_unref(sections_use) && _unref(user).type == 'teacher')
            ? (_openBlock(), _createBlock(_component_custom_select, {
                key: 0,
                selected_option: _unref(selected_section),
                "onUpdate:selected_option": _cache[7] || (_cache[7] = ($event: any) => (_isRef(selected_section) ? (selected_section).value = $event : selected_section = $event)),
                list: sections,
                label: _unref(getCurrentElement)('section') + ':',
                aria_label: _unref(getCurrentElement)('section'),
                placeholder: _unref(getCurrentElement)('section_choice'),
                classes: {
          label: {
            'ion-margin-start': {
              general: true,
              sm: false,
            },
          },
        }
              }, null, 8, ["selected_option", "label", "aria_label", "placeholder"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_list_card, {
          key: trigger.value,
          cards_list: messages,
          columns: _unref(isSmaller)(breakpoint.value, 'md') ? 1 : 3,
          emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)('no_messages')
            )
          ,
          onSignal_event: _cache[8] || (_cache[8] = ($event: any) => (setupModalAndOpen())),
          classes: {
            item: {
              'ion-padding-bottom': {
                md: true,
              },
            },
          }
        }, null, 8, ["columns", "emptiness_message"]))
      ]),
      fallback: _withCtx(() => [
        _createVNode(_component_loading_component)
      ]),
      _: 1
    }))
  ]))
}
}

})